// @flow
import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";

type LicenceCountPropsType = {
  count: number,
  classes: { [key: string]: string }
};

const styles = theme => ({
  root: {
    paddingRight: "18px",
  },
  badge: {
    top: "50%",
  },
});

class LicenceCount extends Component<LicenceCountPropsType, *> {

  render(): * {
    const classes = this.props.classes;
    return (
      <Badge 
        color="primary"
        badgeContent={this.props.count}
        classes={{ badge: classes.badge, root: classes.root }}>
        <Typography variant="subtitle1">Licences</Typography>
      </Badge>
    );
  };
}

export default withStyles(styles)(LicenceCount);
